/**
 * VOLUME PRICING TIERS — live progress bar
 * Adapted for the Hyper theme (Blue Moon Fabrics).
 *
 * Hyper markup differences vs. the original Warehouse/Impulse build:
 *   - quantity input is  <input class="quantity__input" name="quantity" is="quantity-input">
 *     wrapped in a <quantity-selector> custom element (NOT .quantity-selector__value)
 *   - steppers are <button class="quantity__button" name="plus|minus">
 *     (NOT [data-action="increase-picker-quantity"])
 *   - a page can hold several quantity inputs (main form, sticky bar, quick-add),
 *     so we resolve the input nearest to THIS widget rather than the first on the page.
 *
 * Sale awareness: the wrapper carries data-vpt-sale-pct. When a sale is
 * running, the "add more yards" message keeps the current rate in view rather
 * than implying the customer has no discount yet.
 *
 * Copy note: plain and human, no em dashes in customer-facing strings.
 */
(function () {
  'use strict';

  function findQtyInput(wrapper) {
    var scope =
      wrapper.closest('.product') ||
      wrapper.closest('[id^="MainProduct"]') ||
      wrapper.closest('.shopify-section') ||
      document;

    return (
      scope.querySelector('quantity-selector .quantity__input') ||
      scope.querySelector('.quantity__input') ||
      scope.querySelector('input[name="quantity"]') ||
      document.querySelector('quantity-selector .quantity__input') ||
      document.querySelector('.quantity__input') ||
      document.querySelector('input[name="quantity"]')
    );
  }

  function initVolumePricing(root) {
    var wrappers = (root || document).querySelectorAll('.vpt-wrapper');

    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.vptInit === '1') return;
      wrapper.dataset.vptInit = '1';

      var salePct = parseInt(wrapper.dataset.vptSalePct, 10);
      if (isNaN(salePct) || salePct < 0) salePct = 0;

      var tiers = Array.prototype.slice
        .call(wrapper.querySelectorAll('.vpt-tier'))
        .map(function (el) {
          return {
            el: el,
            qty: parseInt(el.dataset.vptQty, 10),
            pct: parseInt(el.dataset.vptPct, 10)
          };
        })
        .filter(function (t) { return !isNaN(t.qty) && !isNaN(t.pct); })
        .sort(function (a, b) { return a.qty - b.qty; });

      if (!tiers.length) return;

      var maxTierQty = tiers[tiers.length - 1].qty;
      var fill = wrapper.querySelector('.vpt-progress-fill');
      var message = wrapper.querySelector('.vpt-message');
      var qtyInput = findQtyInput(wrapper);

      function currentQty() {
        if (!qtyInput) return 1;
        var v = parseInt(qtyInput.value, 10);
        return isNaN(v) || v < 1 ? 1 : v;
      }

      function activeTierFor(qty) {
        var active = null;
        for (var i = 0; i < tiers.length; i++) {
          if (qty >= tiers[i].qty) active = tiers[i];
        }
        return active;
      }

      function nextTierFor(qty) {
        for (var i = 0; i < tiers.length; i++) {
          if (qty < tiers[i].qty) return tiers[i];
        }
        return null;
      }

      function render() {
        var qty = currentQty();
        var active = activeTierFor(qty);
        var next = nextTierFor(qty);

        if (fill) fill.style.width = Math.min((qty / maxTierQty) * 100, 100) + '%';

        tiers.forEach(function (t) {
          t.el.classList.remove('vpt-active', 'vpt-unlocked');
          if (active && t.qty === active.qty) {
            t.el.classList.add('vpt-active', 'vpt-unlocked');
          } else if (active && t.qty < active.qty) {
            t.el.classList.add('vpt-unlocked');
          }
        });

        if (!message) return;
        message.classList.remove('vpt-maxed');

        if (next) {
          var remaining = next.qty - qty;
          var yards = remaining + ' more yard' + (remaining === 1 ? '' : 's');

          // Rate the customer is on right now: a reached tier, or the sale.
          var currentPct = active ? active.pct : salePct;

          if (currentPct > 0) {
            message.innerHTML =
              'You\u2019re getting <strong>' + currentPct + '% off</strong> right now. Add <strong>' +
              yards + '</strong> to make it <strong>' + next.pct + '% off</strong>';
          } else {
            message.innerHTML =
              'Add <strong>' + yards + '</strong> to unlock <strong>' + next.pct + '% off</strong>';
          }
        } else if (active) {
          message.classList.add('vpt-maxed');
          message.innerHTML =
            'You\u2019ve got the biggest discount on this fabric: <strong>' + active.pct + '% off</strong>';
        }
      }

      if (qtyInput) {
        qtyInput.addEventListener('input', render);
        qtyInput.addEventListener('change', render);

        // Hyper's steppers mutate the input programmatically; a programmatic
        // .value change fires no event, so watch the buttons directly.
        var selector = qtyInput.closest('quantity-selector') || qtyInput.parentElement;
        if (selector) {
          selector.addEventListener('click', function (e) {
            if (e.target.closest('button')) setTimeout(render, 0);
          });
        }

        if (typeof MutationObserver !== 'undefined') {
          new MutationObserver(render).observe(qtyInput, {
            attributes: true,
            attributeFilter: ['value']
          });
        }
      }

      render();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initVolumePricing(); });
  } else {
    initVolumePricing();
  }

  document.addEventListener('shopify:section:load', function (e) { initVolumePricing(e.target); });
})();
